import { useState, useEffect, useRef } from "react"

// interface UseAnimatedNumberProps {
//   value: number
//   duration?: number
//   delay?: number
//   enabled?: boolean
// }

export function useAnimatedNumber({ value, duration = 2000, delay = 0, enabled = true }) {
    const [displayValue, setDisplayValue] = useState(0)
    const [isAnimating, setIsAnimating] = useState(false)
    const animationRef = useRef()
    const startTimeRef = useRef()

    // 緩動函數 - easeOutCubic
    const easeOutCubic = (t) => {
        return 1 - Math.pow(1 - t, 3)
    }

    useEffect(() => {
        if (!enabled) {
            setDisplayValue(value)
            return
        }

        const startAnimation = () => {
            setIsAnimating(true)
            startTimeRef.current = performance.now()

            const animate = (currentTime) => {
                if (!startTimeRef.current) return

                const elapsed = currentTime - startTimeRef.current
                const progress = Math.min(elapsed / duration, 1)
                const easedProgress = easeOutCubic(progress)

                const currentValue = Math.floor(value * easedProgress)
                setDisplayValue(currentValue)

                if (progress < 1) {
                    animationRef.current = requestAnimationFrame(animate)
                } else {
                    setDisplayValue(value)
                    setIsAnimating(false)
                }
            }

            animationRef.current = requestAnimationFrame(animate)
        }

        const timeoutId = setTimeout(startAnimation, delay)

        return () => {
            clearTimeout(timeoutId)
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current)
            }
        }
    }, [value, duration, delay, enabled])

    return { displayValue, isAnimating }
}
